var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('svg', {
    attrs: {
      "width": "38",
      "height": "13",
      "viewBox": "0 0 38 5",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M0.506088 4.65664V0.610615C0.506088 0.50892 0.593254 0.429016 0.694949 0.429016H2.45282C3.28817 0.429016 3.91287 1.02466 3.91287 1.80917C3.91287 2.60094 3.29544 3.19658 2.45282 3.19658H1.15984V4.6639C1.15984 4.76559 1.07994 4.8455 0.978244 4.8455H0.694949C0.593254 4.83823 0.506088 4.75833 0.506088 4.65664ZM1.15984 1.03192V2.57914H2.45282C2.89592 2.57914 3.23733 2.24501 3.23733 1.8019C3.23733 1.36607 2.89592 1.03192 2.45282 1.03192H1.15984V1.03192Z",
      "fill": "white"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M5.61262 0.421814H5.89591C5.99761 0.421814 6.07751 0.501717 6.07751 0.603411V4.22809H8.22764C8.32933 4.22809 8.4165 4.31525 8.4165 4.41695V4.64939C8.4165 4.75108 8.32933 4.83099 8.22764 4.83099H5.61262C5.51093 4.83099 5.42376 4.75108 5.42376 4.64939V0.603411C5.42376 0.501717 5.50367 0.421814 5.61262 0.421814Z",
      "fill": "white"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M11.3221 0.581616C11.3584 0.487185 11.4601 0.421814 11.5545 0.421814H11.7434C11.8378 0.421814 11.9395 0.487185 11.9758 0.581616L13.7555 4.66392C13.799 4.75835 13.7482 4.83099 13.6465 4.83099H13.3342C13.2325 4.83099 13.1162 4.75835 13.0727 4.66392L12.7385 3.89395H10.5521L10.2179 4.66392C10.1816 4.75835 10.0654 4.83099 9.9637 4.83099H9.65135C9.54966 4.83099 9.49155 4.75835 9.5424 4.66392L11.3221 0.581616ZM10.8208 3.29105H12.4843L11.6562 1.35159L10.8208 3.29105Z",
      "fill": "white"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M14.5182 0.421814H17.9831C18.092 0.421814 18.1719 0.501717 18.1719 0.603411V0.835852C18.1719 0.937546 18.092 1.02472 17.9831 1.02472H16.5812V4.64939C16.5812 4.75108 16.5012 4.83099 16.3923 4.83099H16.1163C16.0073 4.83099 15.9274 4.75108 15.9274 4.64939V1.02472H14.5255C14.4238 1.02472 14.3366 0.937546 14.3366 0.835852V0.603411C14.3293 0.501717 14.4092 0.421814 14.5182 0.421814Z",
      "fill": "white"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M19.5666 0.603411C19.5666 0.501717 19.6538 0.421814 19.7555 0.421814H20.0388C20.1405 0.421814 20.2204 0.501717 20.2204 0.603411V4.64939C20.2204 4.75108 20.1405 4.83099 20.0388 4.83099H19.7555C19.6538 4.83099 19.5666 4.75108 19.5666 4.64939V0.603411Z",
      "fill": "white"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M22.1017 0.421814H22.3196C22.4213 0.421814 22.5376 0.479922 22.6029 0.559825L25.1017 3.71236V0.610674C25.1017 0.508979 25.1816 0.429076 25.2833 0.429076H25.5376C25.6465 0.429076 25.7264 0.508979 25.7264 0.610674V4.65667C25.7264 4.75836 25.6465 4.83826 25.5448 4.83826H25.3197C25.2252 4.83826 25.1017 4.78015 25.0436 4.70751L22.5521 1.55498V4.65667C22.5521 4.75836 22.4649 4.83826 22.3632 4.83826H22.109C22.0073 4.83826 21.9201 4.75836 21.9201 4.65667V0.610674C21.9129 0.501715 22 0.421814 22.1017 0.421814Z",
      "fill": "white"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M27.3463 3.07309V0.610615C27.3463 0.508919 27.4334 0.429016 27.5351 0.429016H27.8184C27.9201 0.429016 28 0.508919 28 0.610615V3.07309C28 3.77769 28.5376 4.30796 29.2422 4.30796C29.9468 4.30796 30.477 3.77769 30.477 3.07309V0.610615C30.477 0.508919 30.5569 0.429016 30.6659 0.429016H30.9492C31.0509 0.429016 31.1308 0.508919 31.1308 0.610615V3.07309C31.1308 4.1191 30.3172 4.91813 29.2422 4.91813C28.1671 4.91813 27.3463 4.1191 27.3463 3.07309Z",
      "fill": "white"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M32.954 0.421814H33.2373C33.339 0.421814 33.4625 0.494449 33.5134 0.581616L35.1332 3.4218L36.7531 0.581616C36.8039 0.487185 36.9274 0.421814 37.0364 0.421814H37.3196C37.4213 0.421814 37.5012 0.501717 37.5012 0.603411V4.64939C37.5012 4.75108 37.4213 4.83099 37.3196 4.83099H37.0364C36.9347 4.83099 36.8475 4.75108 36.8475 4.64939V1.66394L35.4165 4.1845C35.3802 4.24988 35.293 4.29346 35.2204 4.29346H35.0533C34.9807 4.29346 34.8935 4.24988 34.8572 4.1845L33.4262 1.6712V4.64939C33.4262 4.75108 33.3463 4.83099 33.2446 4.83099H32.9613C32.8596 4.83099 32.7724 4.75108 32.7724 4.64939V0.603411C32.7579 0.501717 32.8451 0.421814 32.954 0.421814Z",
      "fill": "white"
    }
  })]);

}
var staticRenderFns = []

export { render, staticRenderFns }